import React from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import cssClasses from "./VerifyCpDetailsModal.module.css";
import Close from "../../Components/Icons/Close";
import Button from "../../Subcomponents/Button";

function maskAccountNumber(accountNumber) {
  const str = accountNumber ? String(accountNumber) : "";
  if (str.length <= 4) return str || "-";
  return "•".repeat(str.length - 4) + str.slice(-4);
}

function Field({ label, value }) {
  return (
    <div>
      <div className={cssClasses.fieldLabel}>{label}</div>
      <div className={cssClasses.fieldValue}>{value || "-"}</div>
    </div>
  );
}

export default function VerifyCpDetailsModal({
  open,
  handleClose,
  cpProfile,
  onConfirm,
  onChangeDetails,
  isSubmitting,
}) {
  const cp = cpProfile || {};

  return (
    <Modal
      open={open}
      onClose={(_, reason) => {
        if (reason !== "backdropClick") {
          handleClose();
        }
      }}
      aria-labelledby="verify-cp-details-title"
      sx={[
        {
          ".MuiBackdrop-root": {
            background: "rgba(52, 64, 84, 0.7)",
          },
        },
      ]}
      disableAutoFocus={true}
    >
      <Box className={cssClasses.modalWrapper}>
        <div className={cssClasses.header}>
          <div>
            <div id="verify-cp-details-title" className={cssClasses.title}>
              Verify CP Details
            </div>
            <div className={cssClasses.subtitle}>
              Review the CP's profile before raising this invoice
            </div>
          </div>
          <span className={cssClasses.closeIcon} onClick={handleClose}>
            <Close width={"1.4rem"} height={"1.4rem"} />
          </span>
        </div>

        <div className={cssClasses.scrollArea}>
          <div className={cssClasses.section}>
            <div className={cssClasses.sectionTitle}>Basic Information</div>
            <div className={cssClasses.fieldGrid}>
              <Field label="CP Name" value={cp.name} />
              <Field label="Company Name" value={cp.billingName} />
            </div>
          </div>

          <div className={cssClasses.section}>
            <div className={cssClasses.sectionTitle}>PAN Information</div>
            <div className={cssClasses.fieldGrid}>
              <Field label="PAN Number" value={cp.panNumber} />
            </div>
          </div>

          <div className={cssClasses.section}>
            <div className={cssClasses.sectionTitle}>GST Information</div>
            <div className={cssClasses.fieldGrid}>
              <Field label="GST Number" value={cp.gstNumber} />
              <Field
                label="GST Registration Status"
                value={cp.isGSTApplicable ? "Registered" : "Unregistered"}
              />
            </div>
          </div>

          <div className={cssClasses.section}>
            <div className={cssClasses.sectionTitle}>Bank Information</div>
            <div className={cssClasses.fieldGrid}>
              <Field label="Account Holder Name" value={cp.bankAccountHolderName} />
              <Field
                label="Account Number"
                value={maskAccountNumber(cp.bankAccountNumber)}
              />
              <Field label="IFSC Code" value={cp.bankIFSCCode} />
              <Field label="Branch Name" value={cp.bankBranchName} />
            </div>
          </div>

          <div className={cssClasses.section}>
            <div className={cssClasses.sectionTitle}>RERA Information</div>
            <div className={cssClasses.fieldGrid}>
              <Field label="RERA Number" value={cp.reraNumber} />
            </div>
          </div>

          <div className={cssClasses.verificationMessage}>
            Please verify the CP details before raising the invoice.
            <br />
            Once the invoice is generated, these details will be considered
            final for invoice processing.
          </div>
        </div>

        <div className={cssClasses.footer}>
          <Button
            style={{
              color: "#B42318",
              backgroundColor: "#ffffff",
              border: "1px solid #FDA29B",
              fontSize: "1.6rem",
              lineHeight: "2.4rem",
              width: "auto",
            }}
            padding={"1.2rem 2rem"}
            btnName={"Change Details"}
            clicked={onChangeDetails}
            disable={isSubmitting}
          />
          <Button
            style={{
              color: "#ffffff",
              backgroundColor: "#1570EF",
              fontSize: "1.6rem",
              lineHeight: "2.4rem",
              width: "auto",
            }}
            padding={"1.2rem 2.4rem"}
            btnName={"Confirm"}
            clicked={onConfirm}
            disable={isSubmitting}
          />
        </div>
      </Box>
    </Modal>
  );
}
